import React from "react";

import RenderOrientations, {
    RenderOrientationFlow,
} from "../../types/enums/RenderOrientation";

interface PanelHeaderProps {
    className?: string;
    direction?: RenderOrientationFlow;
    spaced?: boolean;

    children?: React.ReactNode | React.ReactNode[];
}

interface PanelHeaderState {}

class PanelHeader extends React.Component<PanelHeaderProps, PanelHeaderState> {
    render(): React.ReactNode {
        let classNames = "header";

        if (this.props.className) classNames += ` ${this.props.className}`;
        if (this.props.spaced) classNames += " spaced";

        switch (this.props.direction) {
            case RenderOrientations.RightLeft:
                classNames += " flex-row-reverse";
                break;
            default:
                classNames += " flex-row";
                break;
        }

        return <div className={classNames}>{this.props.children}</div>;
    }
}

export default PanelHeader;
